import { SubmitBrief } from '@/application/brief/SubmitBrief';
import { AppConfig } from '@/config/AppConfig';
import type { Disposable } from '@/core/Disposable';
import { HttpBriefGateway } from '@/infrastructure/brief/HttpBriefGateway';
import { SimulatedBriefGateway } from '@/infrastructure/brief/SimulatedBriefGateway';
import { FetchHttpClient } from '@/infrastructure/http/FetchHttpClient';
import { MotionEngine } from '@/motion/MotionEngine';
import { DeviceProfile } from '@/platform/DeviceProfile';

/** Les services partagés par toute l'application, injectés via le contexte React. */
export interface AppServices extends Disposable {
  readonly device: DeviceProfile;
  readonly motion: MotionEngine;
  readonly submitBrief: SubmitBrief;
}

/**
 * Racine de composition : le seul endroit qui choisit les implémentations
 * concrètes. Brancher l'API Go = renseigner `VITE_API_BASE_URL`.
 */
export const composeApp = (win: Window): AppServices => {
  const config = AppConfig.fromEnvironment(import.meta.env);
  const device = DeviceProfile.detect(win);
  const motion = new MotionEngine({ smoothScroll: !device.prefersReducedMotion });

  const gateway = config.apiBaseUrl
    ? new HttpBriefGateway(new FetchHttpClient({ baseUrl: config.apiBaseUrl }))
    : new SimulatedBriefGateway();

  return {
    device,
    motion,
    submitBrief: new SubmitBrief(gateway),
    dispose: () => {
      motion.dispose();
    },
  };
};
